import React from "react";
import { DashboardView } from "../../../templates/payment/DashboardView";
import style from "../SettingModal.module.scss";
import { useTranslation } from "react-i18next";

type Props = {
  client: {
    code: string;
    id: number;
    country_code: string;
  };
  members_count: number;
  is_internal: boolean;
  locale: string;
};

const PlanAndBilling = ({ client, members_count, is_internal, locale }: Props) => {
  const { t } = useTranslation();
  return (
    <div>
      <h1 className={`${style.title} ${style.mb24}`}>{t("PlanAndBilling.プラン・支払い")}</h1>
      <DashboardView
        client={client.code}
        country_code={client.country_code}
        members_count={members_count}
        client_id={client.id}
        is_internal={is_internal}
        locale={locale}
      />
    </div>
  );
};

export default PlanAndBilling;
